<footer class="footer">
  <span>© Fortaris · uma solução InforCENTER Sistemas</span>
  <span>Versão: 1.0.1 - © 2026</span>
</footer>
